<div class="custom-dropdown" [style.width]="width">
  <div class="mat-form-field-wrapper">
    <div class="mat-form-field-flex">
      <button mat-button 
              [matMenuTriggerFor]="dropdownMenu" 
              class="dropdown-button"
              [disabled]="disabled"
              [class.has-value]="hasValue()"
              [class.error-state]="errorState"
              (menuOpened)="onMenuOpened()">
        <div class="selected-value">
          @if (showIcon) {
            @if (selectedItem && selectedItem[iconField]) {
              <img *ngIf="selectedItem[iconField].startsWith('http')" [src]="selectedItem[iconField]" class="item-icon" alt="icon">
              <mat-icon *ngIf="!selectedItem[iconField].startsWith('http')">{{selectedItem[iconField]}}</mat-icon>
            } @else if (icon) {
              <mat-icon>{{icon}}</mat-icon>
            }
          }
          @if (hasValue()) {
            {{ getDisplayValue() }}
          }
        </div>
        <mat-icon class="dropdown-icon">keyboard_arrow_down</mat-icon>
      </button>
      @if (label) {
        <div class="dropdown-label" [class.floating]="hasValue()" [class.required]="isRequired()" [class.error-state]="errorState">
          {{ label }}<span class="required-marker" *ngIf="isRequired()">*</span>
        </div>
      }
    </div>
    <div class="mat-form-field-subscript-wrapper" *ngIf="errorState && ngControl?.errors">
      <div class="mat-error" *ngIf="ngControl?.hasError('required')">
        This field is required
      </div>
      <div class="mat-error" *ngIf="ngControl?.hasError('pattern')">
        Invalid format
      </div>
      <div class="mat-error" *ngIf="ngControl?.hasError('minlength')">
        Value is too short
      </div>
      <div class="mat-error" *ngIf="ngControl?.hasError('maxlength')">
        Value is too long
      </div>
      <!-- Add more error messages as needed -->
    </div>
  </div>
  
  <mat-menu #dropdownMenu="matMenu" class="dropdown-menu" [hasBackdrop]="true" (closed)="onMenuClosed()">
    <div class="search-container" (click)="$event.stopPropagation()">
      <div class="search-input-wrapper">
        <input 
          type="text" 
          class="search-input"
          #searchInput
          [formControl]="searchControl"
          [placeholder]="searchPlaceholder"
          (input)="onSearch()">
        <mat-icon class="search-icon">search</mat-icon>
      </div>
    </div>
    
    <div class="menu-items-container">
      @for (item of filteredItems; track $index) {
        @if (multiple) {
          <div class="dropdown-item-multi" 
              
               [class.selected]="isSelected(item)"
               (click)="$event.stopPropagation(); onItemSelect(item, $event)">
            <mat-icon class="checkbox-icon">{{ isSelected(item) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            @if (showIcon) {
              @if (item[iconField]) {
                <img *ngIf="item[iconField].startsWith('http')" [src]="item[iconField]" class="item-icon" alt="icon">
                <mat-icon *ngIf="!item[iconField].startsWith('http')">{{item[iconField]}}</mat-icon>
              }
            }
            <span>{{ item[displayField] }}</span>
          </div>
        } @else {
          <div class="dropdown-item" 
               [class.selected]="isSelected(item)"
               [class.null-option]="item._isNullOption"
               (click)="onItemSelect(item, $event)">
            @if (showIcon) {
              @if (item[iconField]) {
                <img *ngIf="item[iconField].startsWith('http')" [src]="item[iconField]" class="item-icon" alt="icon">
                <mat-icon *ngIf="!item[iconField].startsWith('http')">{{item[iconField]}}</mat-icon>
              }
            }
            <span>{{ item[displayField] }}</span>
          </div>
        }
      }
      
      @if (filteredItems.length === 0) {
        <div class="no-results">
          <mat-icon>search_off</mat-icon>
          <span>No items found</span>
        </div>
      }
      
      @if (addItems) {
        <div class="add-item-container" (click)="$event.stopPropagation()">
          <div class="add-input-wrapper">
            <input 
              type="text" 
              class="add-input"
              [placeholder]="addItemLabel"
              (input)="onNewItemInput($event)"
              (keydown.enter)="addNewItem(); $event.preventDefault()">
            <mat-icon class="edit-icon">edit</mat-icon>
          </div>
        </div>
      }
    </div>
  </mat-menu>
</div> 